export default "__VITE_ASSET__95c5a9ce__"